const baseUrl = SERVICE_URL;

async function get(url) {
  getFetch();

  let token = localStorage.getItem("token");
  let headers = {};

  if (token) {
    headers.Authorization = "Bearer " + token;
  }

  const response = await fetch(`${baseUrl}/${url}`, {
    method: "GET",
    headers,
  })
    .then((response) => response.json())
    .catch((err) => handleError(err));

  return response;
}

async function post(url, payload) {
  return genericRequest("POST", url, payload);
}

async function put(url, payload) {
  return genericRequest("PUT", url, payload);
}
async function remove(url) {
  return genericRequest("DELETE", url);
}
async function genericRequest(type, url, payload) {
  getFetch();

  const response = await fetch(`${baseUrl}/${url}`, {
    method: type,
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  })
    .then((response) => response.json())
    .catch((err) => handleError(err));

  return response;
}
function getFetch() {
  if (typeof fetch !== "function") {
    var global = global;
    if (global === undefined) {
      global = window;
    }
    global.fetch = require("node-fetch");
  }
}
function handleError(err) {
  console.error(err);
}

const API = {
  get,
  post,
  put,
  remove,
};

export default API;
